import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  FormGroup,
  FormField,
  Input,
  Icon
} from 'semantic-ui-react'

const CardClaimInformationDetailUX = (props: any) => {

    const isMounted = React.useRef(true);
    const intl = useIntl();

    React.useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);


    return(
      <div
        id="CardClaimInformationDetailUX-div-0"
        style={{width: "100%",height:"100%",padding:"10px"}}>
        <div
          id="CardClaimInformationDetailUX-div-67"
          style={{marginBottom: "-0.5rem"}}>
          
          <div
            id="CardClaimInformationDetailUX-div-70"
            style={{display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0px 0"}}>
            
            <div
              id="CardClaimInformationDetailUX-div-71"
              style={{fontSize: "1.2rem", fontWeight: "bold"}}>
              {props.languageUX === "en" ? "E-Claim submission details" : "รายละเอียดข้อมูลส่งเบิก E-Claim"}
            </div>
            <div
              className="ui form"
              id="CardClaimInformationDetailUX-div-95">
              
              <div
                className="inline fields"
                id="CardClaimInformationDetailUX-div-96"
                style={{margin: 0}}>
                
                <FormField
                  id="CardClaimInformationDetailUX-FormField-97">
                  <label
                    id="CardClaimInformationDetailUX-label-101">
                    {props.languageUX === "en" ? "REP NO." : "REP NO."}
                  </label>
                </FormField>
                <FormField
                  id="CardClaimInformationDetailUX-FormField-98">
                  <Input
                    id="CardClaimInformationDetailUX-Input-102"
                    name="refNo "
                    onChange={props.onChange}
                    value={props.refNo || ""}>
                  </Input>
                </FormField>
                <FormField
                  id="CardClaimInformationDetailUX-FormField-99">
                  <div
                    id="CardClaimInformationDetailUX-div-133">
                    {props.ButtonEdit}
                  </div>
                </FormField>
                <FormField
                  id="CardClaimInformationDetailUX-FormField-100"
                  width={2}>
                  <div
                    id="CardClaimInformationDetailUX-div-104"
                    style={{cursor: "pointer", margin: "0 -1rem 0 5rem"}}>
                    
                    <Icon
                      className="red large"
                      id="CardClaimInformationDetailUX-Icon-105"
                      name="close"
                      onClick={props.onClose}>
                    </Icon>
                  </div>
                </FormField>
              </div>
            </div>
          </div>
        </div>
        <div
          className="ui divider"
          id="CardClaimInformationDetailUX-div-68">
          
        </div>
        <div
          className="ui form"
          id="CardClaimInformationDetailUX-div-69">
          
          <FormGroup
            id="CardClaimInformationDetailUX-FormGroup-74"
            inline={true}>
            <FormField
              id="CardClaimInformationDetailUX-FormField-77"
              inline={true}>
              <label
                id="CardClaimInformationDetailUX-label-83">
                {props.languageUX === "en" ? "HN:" : "HN:"}
              </label>
            </FormField>
            <FormField
              id="CardClaimInformationDetailUX-FormField-78"
              inline={true}>
              <div
                id="CardClaimInformationDetailUX-div-106">
                {props.detail?.hn || "-"}
              </div>
            </FormField>
            <FormField
              id="CardClaimInformationDetailUX-FormField-107">
              <label
                id="CardClaimInformationDetailUX-label-115"
                style={{marginLeft: "1rem"}}>
                {props.languageUX === "en" ? "Encounter:" : "Encounter:"}
              </label>
            </FormField>
            <FormField
              id="CardClaimInformationDetailUX-FormField-108">
              <div
                id="CardClaimInformationDetailUX-div-119">
                {props.detail?.encounter_id|| "-"}
              </div>
            </FormField>
            <FormField
              id="CardClaimInformationDetailUX-FormField-109">
              <label
                id="CardClaimInformationDetailUX-label-116"
                style={{marginLeft: "1rem"}}>
                {props.languageUX === "en" ? "Name-Surname:" : "ชื่อ-สกุล:"}
              </label>
            </FormField>
            <FormField
              id="CardClaimInformationDetailUX-FormField-110">
              <div
                id="CardClaimInformationDetailUX-div-120">
                {props.detail?.patient_name|| "-"}
              </div>
            </FormField>
            <FormField
              id="CardClaimInformationDetailUX-FormField-111">
              <label
                id="CardClaimInformationDetailUX-label-117"
                style={{marginLeft: "1rem"}}>
                {props.languageUX === "en" ? "clinic:" : "คลินิก:"}
              </label>
            </FormField>
            <FormField
              id="CardClaimInformationDetailUX-FormField-112">
              <div
                id="CardClaimInformationDetailUX-div-121">
                {props.detail?.division_name|| "-"}
              </div>
            </FormField>
            <FormField
              id="CardClaimInformationDetailUX-FormField-113">
              <label
                id="CardClaimInformationDetailUX-label-118"
                style={{marginLeft: "1rem"}}>
                {props.languageUX === "en" ? "Treating Dentist:" : "ทันตแพทย์ผู้รักษา:"}
              </label>
            </FormField>
            <FormField
              id="CardClaimInformationDetailUX-FormField-114">
              <div
                id="CardClaimInformationDetailUX-div-122">
                {props.detail?.doctor_name|| "-"}
              </div>
            </FormField>
            <FormField
              id="CardClaimInformationDetailUX-FormField-123">
              <label
                id="CardClaimInformationDetailUX-label-125"
                style={{marginLeft: "1rem"}}>
                {props.languageUX === "en" ? "Date of service:" : "วันที่รับบริการ:"}
              </label>
            </FormField>
            <FormField
              id="CardClaimInformationDetailUX-FormField-124">
              <div
                id="CardClaimInformationDetailUX-div-126">
                {props.detail?.service_date|| "-"}
              </div>
            </FormField>
          </FormGroup>
        </div>
        <div
          id="CardClaimInformationDetailUX-div-127"
          style={{display: "grid", gridTemplateColumns: "5.25% 1fr", paddingBottom: "0.5rem", marginTop:"1rem"}}>
          
          <div
            id="CardClaimInformationDetailUX-div-128"
            style={{overflowY: "auto", overflowX: "hidden", paddingRight: "5px", height: "calc(-11.5rem + 100dvh)", paddingTop:"0.5rem"}}>
            {props.typeList || []}
          </div>
          <div
            id="CardClaimInformationDetailUX-div-129"
            style={{padding:"0 8px", width: "calc(100vw - 13rem)"}}>
            {}
            <div
              id="CardClaimInformationDetailUX-div-130"
              style={{margin: "0 0 1rem", fontSize:"1.1rem"}}>
              
            </div>
            <div
              id="CardClaimInformationDetailUX-div-131"
              style={{margin: "0 0 1rem", fontSize: "1.1rem"}}>
              {props.title || ""}
            </div>
            <div
              id="CardClaimInformationDetailUX-div-134"
              style={{width: "100%"}}>
              {props.TableElement}
            </div>
          </div>
        </div>
      </div>
    )
}


export default CardClaimInformationDetailUX

export const screenPropsDefault = {"language":"EN"}

/* Date Time : Thu Nov 20 2025 07:17:10 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardClaimInformationDetailUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\",height:\"100%\",padding:\"10px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 67,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardClaimInformationDetailUX-div-67"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"-0.5rem\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 68,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui divider"
        },
        "id": {
          "type": "value",
          "value": "CardClaimInformationDetailUX-div-68"
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": null,
      "id": 69,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardClaimInformationDetailUX-div-69"
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": null,
      "id": 70,
      "name": "div",
      "parent": 67,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardClaimInformationDetailUX-div-70"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", justifyContent: \"space-between\", padding: \"0px 0\"}"
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": null,
      "id": 71,
      "name": "div",
      "parent": 70,
      "props": {
        "children": {
          "type": "value",
          "value": "รายละเอียดข้อมูลส่งเบิก E-Claim",
          "valueEN": "E-Claim submission details"
        },
        "id": {
          "type": "value",
          "value": "CardClaimInformationDetailUX-div-71"
        },
        "style": {
          "type": "code",
          "value": "{fontSize: \"1.2rem\", fontWeight: \"bold\"}"
        }
      },
      "seq": 71,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 74,
      "name": "FormGroup",
      "parent": 69,
      "props": {
        "id": {
          "type": "value",
          "value": "CardClaimInformationDetailUX-FormGroup-74"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 74,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 77,
      "name": "FormField",
      "parent": 74,
      "props": {
        "id": {
          "type": "value",
          "value": "CardClaimInformationDetailUX-FormField-77"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 77,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 78,
      "name": "FormField",
      "parent": 74,
      "props": {
        "id": {
          "type": "value",
          "value": "CardClaimInformationDetailUX-FormField-78"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 78,
      "void": false
    },
    {
      "from": null,
      "id": 83,
      "name": "label",
      "parent": 77,
      "props": {
        "children": {
          "type": "value",
          "value": "HN:",
          "valueEN": "HN:"
        },
        "id": {
          "type": "value",
          "value": "CardClaimInformationDetailUX-label-83"
        }
      },
      "seq": 83,
      "void": false
    },
    {
      "from": null,
      "id": 95,
      "name": "div",
      "parent": 70,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardClaimInformationDetailUX-div-95"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 95,
      "void": false
    },
    {
      "from": null,
      "id": 96,
      "name": "div",
      "parent": 95,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "inline fields"
        },
        "id": {
          "type": "value",
          "value": "CardClaimInformationDetailUX-div-96"
        },
        "style": {
          "type": "code",
          "value": "{margin: 0}"
        }
      },
      "seq": 96,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 97,
      "name": "FormField",
      "parent": 96,
      "props": {
        "id": {
          "type": "value",
          "value": "CardClaimInformationDetailUX-FormField-97"
        }
      },
      "seq": 97,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 98,
      "name": "FormField",
      "parent": 96,
      "props": {
        "id": {
          "type": "value",
          "value": "CardClaimInformationDetailUX-FormField-98"
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 99,
      "name": "FormField",
      "parent": 96,
      "props": {
        "id": {
          "type": "value",
          "value": "CardClaimInformationDetailUX-FormField-99"
        }
      },
      "seq": 99,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 100,
      "name": "FormField",
      "parent": 96,
      "props": {
        "id": {
          "type": "value",
          "value": "CardClaimInformationDetailUX-FormField-100"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 100,
      "void": false
    },
    {
      "from": null,
      "id": 101,
      "name": "label",
      "parent": 97,
      "props": {
        "children": {
          "type": "value",
          "value": "REP NO.",
          "valueEN": "REP NO."
        },
        "id": {
          "type": "value",
          "value": "CardClaimInformationDetailUX-label-101"
        }
      },
      "seq": 101,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 102,
      "name": "Input",
      "parent": 98,
      "props": {
        "id": {
          "type": "value",
          "value": "CardClaimInformationDetailUX-Input-102"
        },
        "name": {
          "type": "value",
          "value": "refNo "
        },
        "onChange": {
          "type": "code",
          "value": "props.onChange"
        },
        "value": {
          "type": "code",
          "value": "props.refNo || \"\""
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": null,
      "id": 104,
      "name": "div",
      "parent": 100,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardClaimInformationDetailUX-div-104"
        },
        "style": {
          "type": "code",
          "value": "{cursor: \"pointer\", margin: \"0 -1rem 0 5rem\"}"
        }
      },
      "seq": 104,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 105,
      "name": "Icon",
      "parent": 104,
      "props": {
        "className": {
          "type": "value",
          "value": "red large"
        },
        "id": {
          "type": "value",
          "value": "CardClaimInformationDetailUX-Icon-105"
        },
        "name": {
          "type": "value",
          "value": "close"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClose"
        }
      },
      "seq": 105,
      "void": false
    },
    {
      "from": null,
      "id": 106,
      "name": "div",
      "parent": 78,
      "props": {
        "children": {
          "type": "code",
          "value": "props.detail?.hn || \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardClaimInformationDetailUX-div-106"
        }
      },
      "seq": 106,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 107,
      "name": "FormField",
      "parent": 74,
      "props": {
        "id": {
          "type": "value",
          "value": "CardClaimInformationDetailUX-FormField-107"
        }
      },
      "seq": 107,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 108,
      "name": "FormField",
      "parent": 74,
      "props": {
        "id": {
          "type": "value",
          "value": "CardClaimInformationDetailUX-FormField-108"
        }
      },
      "seq": 108,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 109,
      "name": "FormField",
      "parent": 74,
      "props": {
        "id": {
          "type": "value",
          "value": "CardClaimInformationDetailUX-FormField-109"
        }
      },
      "seq": 109,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 110,
      "name": "FormField",
      "parent": 74,
      "props": {
        "id": {
          "type": "value",
          "value": "CardClaimInformationDetailUX-FormField-110"
        }
      },
      "seq": 110,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 111,
      "name": "FormField",
      "parent": 74,
      "props": {
        "id": {
          "type": "value",
          "value": "CardClaimInformationDetailUX-FormField-111"
        }
      },
      "seq": 111,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 112,
      "name": "FormField",
      "parent": 74,
      "props": {
        "id": {
          "type": "value",
          "value": "CardClaimInformationDetailUX-FormField-112"
        }
      },
      "seq": 112,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 113,
      "name": "FormField",
      "parent": 74,
      "props": {
        "id": {
          "type": "value",
          "value": "CardClaimInformationDetailUX-FormField-113"
        }
      },
      "seq": 113,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 114,
      "name": "FormField",
      "parent": 74,
      "props": {
        "id": {
          "type": "value",
          "value": "CardClaimInformationDetailUX-FormField-114"
        }
      },
      "seq": 114,
      "void": false
    },
    {
      "from": null,
      "id": 115,
      "name": "label",
      "parent": 107,
      "props": {
        "children": {
          "type": "value",
          "value": "Encounter:",
          "valueEN": "Encounter:"
        },
        "id": {
          "type": "value",
          "value": "CardClaimInformationDetailUX-label-115"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"1rem\"}"
        }
      },
      "seq": 115,
      "void": false
    },
    {
      "from": null,
      "id": 116,
      "name": "label",
      "parent": 109,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อ-สกุล:",
          "valueEN": "Name-Surname:"
        },
        "id": {
          "type": "value",
          "value": "CardClaimInformationDetailUX-label-116"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"1rem\"}"
        }
      },
      "seq": 116,
      "void": false
    },
    {
      "from": null,
      "id": 117,
      "name": "label",
      "parent": 111,
      "props": {
        "children": {
          "type": "value",
          "value": "คลินิก:",
          "valueEN": "clinic:"
        },
        "id": {
          "type": "value",
          "value": "CardClaimInformationDetailUX-label-117"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"1rem\"}"
        }
      },
      "seq": 117,
      "void": false
    },
    {
      "from": null,
      "id": 118,
      "name": "label",
      "parent": 113,
      "props": {
        "children": {
          "type": "value",
          "value": "ทันตแพทย์ผู้รักษา:",
          "valueEN": "Treating Dentist:"
        },
        "id": {
          "type": "value",
          "value": "CardClaimInformationDetailUX-label-118"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"1rem\"}"
        }
      },
      "seq": 118,
      "void": false
    },
    {
      "from": null,
      "id": 119,
      "name": "div",
      "parent": 108,
      "props": {
        "children": {
          "type": "code",
          "value": "props.detail?.encounter_id|| \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardClaimInformationDetailUX-div-119"
        }
      },
      "seq": 119,
      "void": false
    },
    {
      "from": null,
      "id": 120,
      "name": "div",
      "parent": 110,
      "props": {
        "children": {
          "type": "code",
          "value": "props.detail?.patient_name|| \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardClaimInformationDetailUX-div-120"
        }
      },
      "seq": 120,
      "void": false
    },
    {
      "from": null,
      "id": 121,
      "name": "div",
      "parent": 112,
      "props": {
        "children": {
          "type": "code",
          "value": "props.detail?.division_name|| \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardClaimInformationDetailUX-div-121"
        }
      },
      "seq": 121,
      "void": false
    },
    {
      "from": null,
      "id": 122,
      "name": "div",
      "parent": 114,
      "props": {
        "children": {
          "type": "code",
          "value": "props.detail?.doctor_name|| \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardClaimInformationDetailUX-div-122"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 122,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 123,
      "name": "FormField",
      "parent": 74,
      "props": {
        "id": {
          "type": "value",
          "value": "CardClaimInformationDetailUX-FormField-123"
        }
      },
      "seq": 123,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 124,
      "name": "FormField",
      "parent": 74,
      "props": {
        "id": {
          "type": "value",
          "value": "CardClaimInformationDetailUX-FormField-124"
        }
      },
      "seq": 124,
      "void": false
    },
    {
      "from": null,
      "id": 125,
      "name": "label",
      "parent": 123,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่รับบริการ:",
          "valueEN": "Date of service:"
        },
        "id": {
          "type": "value",
          "value": "CardClaimInformationDetailUX-label-125"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"1rem\"}"
        }
      },
      "seq": 125,
      "void": false
    },
    {
      "from": null,
      "id": 126,
      "name": "div",
      "parent": 124,
      "props": {
        "children": {
          "type": "code",
          "value": "props.detail?.service_date|| \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardClaimInformationDetailUX-div-126"
        }
      },
      "seq": 126,
      "void": false
    },
    {
      "from": null,
      "id": 127,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardClaimInformationDetailUX-div-127"
        },
        "style": {
          "type": "code",
          "value": "{display: \"grid\", gridTemplateColumns: \"5.25% 1fr\", paddingBottom: \"0.5rem\", marginTop:\"1rem\"}"
        }
      },
      "seq": 127,
      "void": false
    },
    {
      "from": null,
      "id": 128,
      "name": "div",
      "parent": 127,
      "props": {
        "children": {
          "type": "code",
          "value": "props.typeList || []"
        },
        "id": {
          "type": "value",
          "value": "CardClaimInformationDetailUX-div-128"
        },
        "style": {
          "type": "code",
          "value": "{overflowY: \"auto\", overflowX: \"hidden\", paddingRight: \"5px\", height: \"calc(-11.5rem + 100dvh)\", paddingTop:\"0.5rem\"}"
        }
      },
      "seq": 128,
      "void": false
    },
    {
      "from": null,
      "id": 129,
      "name": "div",
      "parent": 127,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardClaimInformationDetailUX-div-129"
        },
        "style": {
          "type": "code",
          "value": "{padding:\"0 8px\", width: \"calc(100vw - 13rem)\"}"
        }
      },
      "seq": 129,
      "void": false
    },
    {
      "from": null,
      "id": 130,
      "name": "div",
      "parent": 129,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardClaimInformationDetailUX-div-130"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0 0 1rem\", fontSize:\"1.1rem\"}"
        }
      },
      "seq": 130,
      "void": false
    },
    {
      "from": null,
      "id": 131,
      "name": "div",
      "parent": 129,
      "props": {
        "children": {
          "type": "code",
          "value": "props.title || \"\""
        },
        "id": {
          "type": "value",
          "value": "CardClaimInformationDetailUX-div-131"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0 0 1rem\", fontSize: \"1.1rem\"}"
        }
      },
      "seq": 131,
      "void": false
    },
    {
      "from": null,
      "id": 133,
      "name": "div",
      "parent": 99,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ButtonEdit"
        },
        "id": {
          "type": "value",
          "value": "CardClaimInformationDetailUX-div-133"
        }
      },
      "seq": 133,
      "void": false
    },
    {
      "from": null,
      "id": 134,
      "name": "div",
      "parent": 129,
      "props": {
        "children": {
          "type": "code",
          "value": "props.TableElement"
        },
        "id": {
          "type": "value",
          "value": "CardClaimInformationDetailUX-div-134"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 134,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 85,
  "isMounted": true,
  "memo": false,
  "name": "CardClaimInformationDetailUX",
  "project": "CLM CU",
  "screenPropsDefault": {
    "language": "EN"
  },
  "width": 70
}

*********************************************************************************** */
